<!-- If blades is activated, show the bladecontainer with a map -->
<ng-container>
  <div class="display-wrapper">
    @if (leftPanelVisible) {
      @if (leftPanelVisible) {
        <app-selection-overview></app-selection-overview>
      }
    }

    <app-blade-container class="blade-container"></app-blade-container>
    <places-map class="map"></places-map>

    <app-history-scrubbar class="scrub-bar" [style]="{left:left}"></app-history-scrubbar>

    <div class="right-panel-wrapper">
      <div class="flex-spacer"></div>
    </div>

    <div class="right-blade-wrapper">
      <app-blade class="right-blade2" name="outlet-right2" [bladeIndex]="1"></app-blade>
      <app-blade class="right-blade1" name="outlet-right1" [bladeIndex]="1"></app-blade>
      <app-blade class="right-blade0" name="outlet-right0" [bladeIndex]="1"></app-blade>
    </div>
  </div>
</ng-container>